export default {"src":"/_next/static/media/trade-in.73b0fdee.svg","height":14,"width":15};